import { render, staticRenderFns } from "./ContentWithSidebar.vue?vue&type=template&id=30ff379e&scoped=true&"
import script from "./ContentWithSidebar.vue?vue&type=script&lang=js&"
export * from "./ContentWithSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ContentWithSidebar.vue?vue&type=style&index=0&id=30ff379e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff379e",
  null
  
)

export default component.exports